export default __webpack_public_path__ + "static/media/DescribingPeople_02.96392575.png";